import React from 'react';
import classnames from 'classnames';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text9 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {identifyMethodType, sharedParts} = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(sharedParts) && identifyMethodType === 1 && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={classnames(styles.bold, styles.itemNumber)}>-   </span>
          <span className={styles.bold}>החלק ברכוש המשותף: </span>
          <span>{sharedParts} </span>
        </div>
      )}
    </div>
  );
});

export default Section8Text9;
